
import { useState, useEffect } from 'react';
import { verifySuapabaseConnection } from '@/services/inventoryService';
import { InventoryItem } from '@/types/inventory';

export function useInventoryConnection() {
  const [lastUpdate, setLastUpdate] = useState<string | null>(null);
  const [sampleProducts, setSampleProducts] = useState<InventoryItem[]>([]);
  const [connectionVerified, setConnectionVerified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Fetch initial sample products to verify connection
  useEffect(() => {
    const verifyConnection = async () => {
      setIsLoading(true);
      try {
        const { samples, lastUpdate: timestamp } = await verifySuapabaseConnection();
        
        if (timestamp) {
          setLastUpdate(timestamp);
        }
        
        setSampleProducts(samples);
        setConnectionVerified(true);
      } finally {
        setIsLoading(false);
      }
    };

    verifyConnection();
  }, []);

  return {
    lastUpdate,
    setLastUpdate,
    sampleProducts,
    connectionVerified,
    isLoading
  };
}
